// extracted by mini-css-extract-plugin
module.exports = {"headata":"headerTimer_headata__gLHAQ"};